<template>
  <div id="MSTestHome">
    <p>MSTestHome</p>
  </div>
</template>

<script>
export default {
  name: "MSTestHome",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>                                                                                                                  
<style lang='scss' scoped>
</style>


// WEBPACK FOOTER //
// src/views/test/ms-testHome.vue